import * as React from 'react';

import {CheckmarkButton} from '../button/checkmark-button/checkmark-button';
import {RemoveButton} from '../button/remove-button/remove-button';
import {Checkbox} from '../checkbox/checkbox';
import {DraggableList} from '../draggable-row/draggable-list';
import {Label} from '../form/label';
import {Stack} from '../layout/stack/stack';
import {TextField} from '../textfield/textfield';

import styles from './create-decision-field-choices.module.css';

type Props = {
    choices: string[];
    onUpdateChoices: (choices: string[]) => void;
    hasAllowMultipleSelection?: {
        allowMultiple: boolean;
        toggleAllowMultiple: () => void;
    };
};

export function CreateDecisionFieldChoices(props: Props) {
    const [newChoiceName, setNewChoiceName] = React.useState<string>('');

    // Validation of entered new choice name
    const isChoiceNameValid =
        newChoiceName.trim() && !props.choices.find((choice) => choice === newChoiceName.trim());

    function handleAddItem(choice: string) {
        if (isChoiceNameValid) {
            props.onUpdateChoices([...props.choices, choice]);
            setNewChoiceName('');
        }
    }

    function handleRemoveItem(choice: string) {
        props.onUpdateChoices(props.choices.filter((c) => c !== choice));
    }

    function handleReorder(startIndex: number, endIndex: number) {
        const reorderedChoices = Array.from(props.choices);
        const [removed] = reorderedChoices.splice(startIndex, 1);
        // @ts-expect-error
        reorderedChoices.splice(endIndex, 0, removed);
        props.onUpdateChoices(reorderedChoices);
    }

    return (
        <Stack spacing={8}>
            <div>
                <Label htmlFor='create-custom-field-option'>Field options</Label>
                <div className={styles['create-choice-wrapper']}>
                    <TextField
                        // @ts-expect-error
                        name='create-custom-field-option'
                        placeholder='Add option…'
                        onChange={(value) => setNewChoiceName(value)}
                        value={newChoiceName}
                        onEnter={(e) => {
                            e.preventDefault();
                            handleAddItem(newChoiceName);
                        }}
                    />
                    <CheckmarkButton
                        onClick={() => handleAddItem(newChoiceName)}
                        isDisabled={!isChoiceNameValid}
                    />
                </div>
            </div>
            {props.choices.length > 0 && (
                <DraggableList
                    isInModal={true}
                    listItems={props.choices.map((choice) => ({
                        id: choice,
                        component: (
                            <div className='flex pad-8 align-center justify-sb'>
                                <div>{choice}</div>
                                <RemoveButton
                                    size={13}
                                    onClick={() => {
                                        handleRemoveItem(choice);
                                    }}
                                />
                            </div>
                        ),
                    }))}
                    handleReorder={handleReorder}
                />
            )}
            {props.hasAllowMultipleSelection ? (
                <Checkbox
                    isLarge={true}
                    label='Allow more than one option to be selected'
                    checked={props.hasAllowMultipleSelection.allowMultiple}
                    onChange={props.hasAllowMultipleSelection.toggleAllowMultiple}
                />
            ) : undefined}
        </Stack>
    );
}
